<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$attrs">
    <template #title>
      <icon-font :type="`icon-${menuInfo.icon}`" v-if="menuInfo.icon" />
      <!-- <span>{{ menuInfo.name }}</span> -->
      <a-badge :count="messageArr.filter(i => i.menuCode == menuInfo.menuCode)[0].menuMessageNum" :overflow-count="99"
        :offset="[10, 0]" v-if="messageArr.filter(i => i.menuCode == menuInfo.menuCode).length > 0">
        <span :class="menuInfo.str == 2 ? 'secondClass' : ''">{{ menuInfo.name }}</span>
      </a-badge>
      <span v-else :class="menuInfo.str == 2 ? 'secondClass' : ''">{{ menuInfo.name }}</span>
    </template>
    <template v-for="item in menuInfo.children" :key="item.key">
      <template v-if="!item.children">
        <a-menu-item :key="item.key">
          <a>
            <icon-font :type="`icon-${item.icon}`" v-if="item.icon" />
            <!-- <span>{{ item.name }}</span> -->
            <a-badge :count="messageArr.filter(i => i.menuCode == item.menuCode)[0].menuMessageNum" :overflow-count="99"
              :offset="[10, 0]" v-if="messageArr.filter(i => i.menuCode == item.menuCode).length > 0">
              <span :class="item.str == 3 ? 'thirdClass' : ''">{{ item.name }}</span>
            </a-badge>
            <span v-else :class="item.str == 3 ? 'thirdClass' : ''">{{ item.name }}</span>
          </a>
        </a-menu-item>
      </template>
      <template v-else>
        <sub-menu :menu-info="item" :key="item.key" :messageArr="messageArr" />
      </template>
    </template>
  </a-sub-menu>
</template>

<script>

export default {
  name: "SubMenu",
  props: {
    menuInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    messageArr: {
      type: Array,
      default() {
        return []
      },
    },
  },

}
</script>

<style scoped lang="less">

:deep(.ant-badge) {
  color: rgba(0, 0, 0, 0.65);
}
:deep(.ant-menu-light .ant-menu-submenu-title:hover){
    color:#000;
}
:deep(.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected){
    background-color: #0059b5;
}
//:deep(.ant-menu-submenu-title:hover){
//    color:#000;
//}
</style>
